import type { NPCConfig } from '@/entities';
import V2EndingNodes from "@/config/NPCConfigs/v2/V2EndingNodes";

const config: NPCConfig[] = [
  {
    x: 880,
    y: 1170,
    name: 'Elsa',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/sprite_elsa.png',
    flipSprite : true,
    repeatable : true,
    dialogTree: {
      startDialogId: 'elsa_1',
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Banyak kenangan baik di tempat ini. Walau hanya sebentar`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Tetapi, sudah saatnya aku pulang`,
          characterImage: '/assets/character/v2/elsa_a.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          storyAction: { type: 'nextDay', value: 0 },
        }
      },
    },
  },
  {
    x: 1000,
    y: 1230,
    name: '',
    color: 0x9932cc,
    spriteImage: 'assets/sprite/nada.png',
    flipSprite : true,
    repeatable : true,
    dialogTree: {
      startDialogId: 'bad_1',
      triggerOnCollision: true,
      nodes: V2EndingNodes.GAME_OVER_ENDING,
    },
  },
];

export default config;
